import api from './Api';
import { LoginResponse, loginResponseFromResponse } from '../interfaces/Auth';

const authBaseUrl = '/auth';

export const login = async (
  username: string,
  password: string,
): Promise<LoginResponse> => {
  const response = await api.post(`${authBaseUrl}/login`, {
    username,
    password,
  });

  return loginResponseFromResponse(response.data);
};
